import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigation } from '../../navigation/react-redux-nav';
import { setConnectedProduct } from '../../store/ducks/connected-product';
import Icon, { NAMES } from '@ifit/react-icons';
import ProductButton from '../../components/product-button';
import cardioImage from './img/cardio-icon.png';
import fusionImage from './img/fusion-icon.png';
import sleepImage from './img/sleep-icon.png';
import altraImage from './img/altra-icon.png';

import './index.css';

export class OtherProductSelectionPage extends Component {
  constructor(props) {
    super(props);

    this.handleBack = () => props.handleNonWearableProductSelected(null);
    this.handleCardioSelected = () => props.handleNonWearableProductSelected('cardio');
    this.handleFusionSelected = () => props.handleNonWearableProductSelected('fusion');
    this.handleSleepSensorSelected = () => props.handleNonWearableProductSelected('sleep');
    this.handleIQShoesSelected = () => props.handleNonWearableProductSelected('altra-iq');
  }

  render() {
    return (
      <div className="product-selection">
        <Navigation.Backward onClick={ this.handleBack }>
          <Icon
            className="back-arrow"
            name={ NAMES.ARROW_LEFT }
            color={ 'white' }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>
        <div className="product-content">

          <h1>What product do you have?</h1>

          <Navigation.Forward onClick={ this.handleCardioSelected }>
            <ProductButton image={ cardioImage } alt="Cardio" text="Cardio Equipment" />
          </Navigation.Forward>

          <Navigation.Forward onClick={ this.handleSleepSensorSelected }>
            <ProductButton image={ sleepImage } alt="Sleep" text="Sleep Sensor" />
          </Navigation.Forward>

          <Navigation.Forward onClick={ this.handleFusionSelected }>
            <ProductButton image={ fusionImage } alt="Fusion" text="Fusion CST" />
          </Navigation.Forward>

          <Navigation.Forward onClick={ this.handleIQShoesSelected }>
            <ProductButton image={ altraImage } alt="Altra" text="IQ Shoes" />
          </Navigation.Forward>
        </div>
      </div>
    );
  }
}

OtherProductSelectionPage.propTypes = {
  handleNonWearableProductSelected: PropTypes.func.isRequired
};

export default connect(
  null,
  (dispatch) => {
    return {
      handleNonWearableProductSelected: product => dispatch(setConnectedProduct(product))
    };
  }
)(OtherProductSelectionPage);